import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'

type Props = {
  years: number[]
  value: number | null
  onChange: (year: number | null) => void
}

export function WhalesStartYearSelect({ years, value, onChange }: Props) {
  return (
    <Box minWidth={140} maxWidth={200}>
      <FormControl fullWidth size="small">
        <InputLabel>Start year</InputLabel>
        <Select value={value ?? ''} label="Start year" onChange={e => onChange(e.target.value)}>
          <MenuItem value="">All years</MenuItem>

          {years.map(year => (
            <MenuItem key={year} value={year}>
              From {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
